import { cn } from "@/lib/utils";

interface WaveformCrossProps {
  className?: string;
}

/**
 * A horizontal audio waveform that subtly forms a cross at its center.
 * Used as a section divider — blending music + faith symbolism.
 */
export const WaveformCross = ({ className }: WaveformCrossProps) => {
  // Waveform bar heights — taller in the center to form a cross
  const bars = [
    4, 8, 6, 10, 7, 5, 9, 12, 8, 14,
    10, 16, 12, 20, 14, 24, 18, 28, 22, 36, // rising toward center
    44, // cross vertical peak (left of center)
    56, // cross center — tallest
    44, // cross vertical peak (right of center)
    36, 22, 28, 18, 24, 14, 20, 12, 16, 10,
    14, 8, 12, 9, 5, 7, 10, 6, 8, 4,
  ];

  return (
    <div className={cn("flex items-center justify-center py-6", className)}>
      <div className="flex items-center gap-[2px]" role="img" aria-label="Waveform cross divider">
        {bars.map((height, i) => {
          const isCenter = i >= 20 && i <= 22;
          return (
            <div
              key={i}
              className={cn(
                "rounded-full",
                isCenter ? "bg-accent" : "bg-accent/40"
              )}
              style={{
                width: isCenter ? "3px" : "2px",
                height: `${height}px`,
                opacity: isCenter ? 0.9 : 0.5,
              }}
            />
          );
        })}
      </div>
    </div>
  );
};
